import React from 'react';

export default function CTASection() {
    return (
        <section className="relative pb-16 sm:pb-24 bg-white overflow-hidden">
            {/* Top Decorative Line */}
            <div className="absolute top-0 left-0 w-full h-24 transform -translate-y-1/2 z-10 pointer-events-none">
                <svg className="w-full h-full text-blue-500 opacity-20" preserveAspectRatio="none" viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 50 L 300 20 L 600 80 L 900 30 L 1200 70 L 1440 40" stroke="currentColor" strokeWidth="2" vectorEffect="non-scaling-stroke" />
                </svg>
            </div>

            <div className="container mx-auto px-4 sm:px-6 lg:px-12 relative z-20">
                <div className="relative rounded-[24px] sm:rounded-[40px] overflow-hidden shadow-2xl bg-[#091020] text-white">
                    {/* Background Pattern */}
                    <div className="absolute inset-0 opacity-20"
                        style={{
                            backgroundImage: 'linear-gradient(#1e3a8a 1px, transparent 1px), linear-gradient(90deg, #1e3a8a 1px, transparent 1px)',
                            backgroundSize: '60px 60px'
                        }}
                    />

                    {/* Glow Effects */}
                    <div className="absolute top-[-200px] left-[-200px] w-[600px] h-[600px] bg-blue-600/20 rounded-full blur-[120px]"></div>
                    <div className="absolute bottom-[-200px] right-[-200px] w-[600px] h-[600px] bg-indigo-600/20 rounded-full blur-[120px]"></div>

                    <div className="relative z-10 py-12 sm:py-16 lg:py-24 px-5 sm:px-8 md:px-16 text-center space-y-6 sm:space-y-8">
                        <div className="inline-block px-3 sm:px-4 py-1 sm:py-1.5 rounded-full border border-blue-500/30 bg-blue-500/10 text-blue-400 text-[10px] sm:text-xs font-bold tracking-widest uppercase">
                            HURRY UP
                        </div>

                        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold tracking-tight">
                            Let's Transform your business!
                        </h2>

                        <p className="text-gray-400 text-sm sm:text-base lg:text-lg max-w-2xl mx-auto leading-relaxed">
                            We have helped multiple startups, enterprises and software product development companies to streamline their outsourcing experience without any hassle.
                        </p>

                        <div className="pt-4 sm:pt-8 flex justify-center">
                            <a href="#footer-consultation" className="bg-white text-blue-900 px-5 sm:px-6 py-2.5 sm:py-3 rounded-full font-bold text-sm sm:text-base hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 shadow-[0_0_20px_rgba(255,255,255,0.3)] inline-flex items-center gap-2 cursor-pointer">
                                <span>Book a Consultation</span>
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg>
                            </a>
                        </div>
                    </div>

                    {/* Decorative Lines/Circuits */}
                    <div className="absolute inset-x-0 bottom-0 h-32 opacity-30 pointer-events-none">
                        <svg className="w-full h-full text-blue-500" preserveAspectRatio="none" viewBox="0 0 1000 200">
                            <path d="M100 200 L 100 100 L 200 100 L 200 50" stroke="currentColor" fill="none" strokeWidth="1" />
                            <path d="M800 200 L 800 120 L 700 120 L 700 60" stroke="currentColor" fill="none" strokeWidth="1" />
                            <circle cx="200" cy="50" r="3" fill="currentColor" />
                            <circle cx="700" cy="60" r="3" fill="currentColor" />
                        </svg>
                    </div>
                </div>
            </div>
        </section>
    );
}
